<script>
    export let href;
    export let image;
    export let title;
</script>

<a {href}>
    <div class="blog-article-item">
        <img src={image} alt="Blog Article" class="blog-article-image" />
        <h3>{title}</h3>
    </div>
</a>

<style>
    a {
        flex: 1;
        text-decoration: none;
    }

    div.blog-article-item {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: start;
        gap: 8px;
    }

    div.blog-article-item h3 {
        font-family: var(--font-body);
        font-size: 20px;
        letter-spacing: -0.8px;
    }

    img.blog-article-image {
        width: 100%;
        height: 250px;
        border-radius: 16px;
        object-fit: cover;
        background-color: var(--surface-container);
    }
</style>
